import { alpha, buttonClasses, Breakpoint } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../../mp-core/themes/palette"

export type RuleName =
  | "mainLinksDropDown"
  | "paper"
  | "mainButton"
  | "mainButtonIcon"
  | "menuList"
  | "menuListItem"
  | "menuItemSelected"
  | "menuListItemText"
  | "typographyButtonSelect"
  | "buttonSelectProductBox"
  | "menuListItemWithSecondary"

export const useStyles = makeStyles<void, RuleName>()(
  ({ palette, breakpoints, spacing, shadows }, _, classes) => ({
    mainLinksDropDown: {
      display: "flex",
      marginRight: spacing(2),
      marginLeft: spacing(2),
      minHeight: "46px",
      zIndex: 1,
      position: "relative",
      [breakpoints.down("md" as Breakpoint)]: {
        display: "block"
      }
    },
    paper: {
      marginRight: spacing(2),
      width: "195px",
      borderRadius: "4px",
      borderTopLeftRadius: 0,
      boxShadow: shadows[1]
    },
    mainButton: {
      backgroundColor: palette.primary[500],
      transition: "border-radius 0.25s ease-out",
      color: "#fff",
      padding: spacing(2, 5),
      fontSize: "0.9375rem",
      minHeight: 46,
      "&:hover": {
        backgroundColor: palette.primary[600]
      },
      "&[aria-controls=products-dropdown-menu]": {
        border: "1px solid #4dbbdf",
        backgroundColor: "white",
        color: palette.primary.main,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,

        [`&:has(+ #products-dropdown-menu) .${classes.typographyButtonSelect}`]:
          {
            color: blueGrey[600]
          },
        [`&:has(+ #products-dropdown-menu) .${classes.buttonSelectProductBox}`]:
          {
            color: blueGrey[800]
          }
      },
      "&:focus, &:focus-visible": {
        outline: `2px solid ${alpha(lightBlue[200], 0.2)}`,
        border: `1px solid ${lightBlue[300]}`
      },
      [`&:disabled, &.${buttonClasses.disabled}`]: {
        boxShadow: "none !important",
        cursor: "default",
        color: palette.common.white,
        backgroundColor: palette.primary[700]
      },
      [breakpoints.down("md" as Breakpoint)]: {
        width: "100%",
        justifyContent: "space-between"
      },
      [breakpoints.up("md" as Breakpoint)]: {
        backgroundColor: palette.primary.main
      }
    },
    mainButtonIcon: {
      fontSize: "0.6875rem"
    },
    menuList: {
      color: palette.primary[500],
      fontSize: "0.6875rem",
      padding: spacing(2, 0),
      [breakpoints.down("md" as Breakpoint)]: {
        width: "100%"
      }
    },
    menuListItem: {
      paddingBottom: spacing(2),
      paddingTop: spacing(2),
      border: "1px solid transparent"
    },
    menuItemSelected: {
      backgroundColor: `${palette.secondary[50]} !important`,
      borderColor: `${palette.secondary[50]}`
    },
    menuListItemText: {
      "& span": {
        fontSize: "0.88rem",
        fontWeight: "400"
      }
    },
    typographyButtonSelect: {
      lineHeight: 1,
      marginRight: "2.625rem",
      marginBottom: "2px",
      color: blueGrey[100]
    },
    buttonSelectProductBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      fontSize: "14px",
      lineHeight: "16px"
    },

    menuListItemWithSecondary: {
      "& p": {
        fontSize: "0.88rem",
        color: "#37474F"
      },
      "& span": {
        fontSize: "0.68rem !important",
        fontWeight: 500
      }
    }
  })
)
